// Import Dependencies
import { NavLink } from "react-router";
import { ScrollShadow } from "components/ui";
import clsx from "clsx";

// ----------------------------------------------------------------------

export function Tabs({ tabs, className }) {
  if (!tabs || tabs.length === 0) return null;
  return null;
  return (
    <ScrollShadow
      orientation="horizontal"
      className={clsx(
        "mb-6 flex space-x-1 rounded-xl bg-slate-100/80 p-1.5 dark:bg-dark-700/50 backdrop-blur-sm no-scrollbar whitespace-nowrap self-start",
        className
      )}
      size={20}
    >
      {tabs.map((tab) => (
        <NavLink
          key={tab.name}
          to={tab.path}
          className={({ isActive }) =>
            clsx(
              "flex-1 min-w-max rounded-lg px-6 py-1.5 text-center text-xs font-bold uppercase tracking-widest transition-all duration-300 focus:outline-none",
              isActive
                ? "bg-white text-primary shadow-sm dark:bg-dark-600 dark:text-primary-light scale-[1.02]"
                : "text-slate-500 hover:text-slate-900 hover:bg-white/50 dark:text-dark-300 dark:hover:text-dark-100 dark:hover:bg-dark-500/30"
            )
          }
        >
          {tab.name}
        </NavLink>
      ))}
    </ScrollShadow>
  );
}
